Date.prototype.format = function(format) {
	var o = {
		"M+": this.getMonth() + 1, //月
		"d+": this.getDate(), //天
		"H+": this.getHours(), //时
		"m+": this.getMinutes(), //分
		"s+": this.getSeconds(), //秒
	}
	if (/(y+)/.test(format)) {
		format = format.replace(RegExp.$1,(this.getFullYear() + "").substr(4 - RegExp.$1.length))
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(format)){
			format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
		}	
	}
	return format;
}



// WEBPACK FOOTER //
// ./src/util/conversionDate.js